import { useTranslation } from "react-i18next";
import { MessageCircle } from "lucide-react";
import { useLocation } from "react-router-dom";
import { CONTACT } from "../lib/api";
import { trackConversion } from "../lib/gtag";

export default function FloatingWhatsApp() {
  const { t } = useTranslation();
  const { pathname } = useLocation();
  if (pathname.startsWith("/admin")) return null;

  return (
    <a
      href={`https://wa.me/${CONTACT.whatsapp}?text=${encodeURIComponent(t("whatsapp_float.prefill"))}`}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="floating-whatsapp"
      onClick={() => trackConversion("whatsapp_click", { location: "floating" })}
      className="hidden lg:flex fixed right-6 bottom-6 z-40 items-center gap-3 bg-[#25D366] hover:bg-[#1EBE5B] text-white pl-4 pr-5 py-3.5 shadow-[0_10px_30px_-8px_rgba(37,211,102,0.5)] transition-all hover:pr-6 group border-2 border-white/20"
    >
      <span className="relative flex items-center justify-center">
        <span className="absolute w-full h-full rounded-full bg-white/30 animate-ping" />
        <MessageCircle className="w-6 h-6 relative z-10" strokeWidth={2.4} />
      </span>
      <span className="flex flex-col leading-tight">
        <span className="font-display text-sm uppercase tracking-wider">{t("whatsapp_float.label")}</span>
        <span className="text-[10px] uppercase tracking-widest text-white/85 font-bold">{t("whatsapp_float.sub")}</span>
      </span>
    </a>
  );
}
